import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { ReportAdapterService } from '../../services/report-adapter.service';
import { ReportAnalysisAPIService } from '../../services/report-analysis-api.service';
import { ReportAnalysisService } from '../../services/report-analysis.service';
import * as ReportActions from './cost-analysis.actions';

@Injectable()
export class CostAnalysisEffect {
    private _actions$ = inject(Actions);
    private _store = inject(Store);
    private reportAPI = inject(ReportAnalysisAPIService);
    private reportAnalysis = inject(ReportAnalysisService);
    private adapter = inject(ReportAdapterService);

    // -----------------------------------------------------------
    // @ Effects
    // -----------------------------------------------------------
    // -----------------------------------------------------------
    // @ Cost Analysis Report Effects
    // -----------------------------------------------------------

    generateCostAnalysisReport$ = createEffect(() =>
        this._actions$.pipe(
            ofType(ReportActions.generateCostAnalysis),
            switchMap(() =>
                this.reportAPI.getCostAnalysisReport().pipe(
                    // Debug
                    // tap((res) => {
                    //     console.log('getCostAnalysisReport:', res);
                    // }),
                    map((res) =>
                        this.adapter.adaptCostAnalysisReport(res.data)
                    ),
                    tap((report) =>
                        this.reportAnalysis.getCostAnalysisFilters(report)
                    ),
                    map((report) =>
                        ReportActions.generateCostAnalysisSuccess({
                            report,
                        })
                    ),
                    catchError((error) =>
                        of(
                            ReportActions.generateCostAnalysisFailure({
                                error: error.error?.message || 'Unknown Error',
                            })
                        )
                    )
                )
            )
        )
    );
}
